import { cn } from '../lib/cn.js';
import { Button } from './ui.js';

/**
 * The sub-trips of the open trip (#29): choose which one the panel edits, add
 * one, merge the open one with the next, or delete it. Shown only once a trip
 * has several; a trip with one looks like a plain trip.
 */
export function SubtripBar({ count, selected, canAdd, canMerge, mergeTitle, onSelect, onAdd, onMerge, onDelete }: {
  count: number;
  selected: number;
  canAdd: boolean;
  canMerge: boolean;
  /** Why merging is not possible, when it is not. */
  mergeTitle?: string;
  onSelect: (index: number) => void;
  onAdd: () => void;
  onMerge: () => void;
  onDelete: () => void;
}) {
  return (
    <div className="subtrip-bar" role="group" aria-label="Sub-trips">
      <div className="subtrip-tabs">
        {Array.from({ length: count }, (_, index) => (
          <button key={index} type="button" className={cn('subtrip-tab', index === selected && 'subtrip-tab-active')} aria-pressed={index === selected} onClick={() => onSelect(index)}>
            Sub-trip {index + 1}
          </button>
        ))}
        <Button type="button" variant="quiet" onClick={onAdd} disabled={!canAdd} title={canAdd ? 'Add a sub-trip after the last' : 'Give the last sub-trip a destination first'}>+ Add sub-trip</Button>
      </div>
      <div className="subtrip-actions">
        {selected < count - 1 ? <Button type="button" variant="quiet" onClick={onMerge} disabled={!canMerge} title={mergeTitle}>Merge with next sub-trip</Button> : null}
        <Button type="button" variant="quiet" onClick={onDelete}>Delete this sub-trip</Button>
      </div>
    </div>
  );
}
